export default __webpack_public_path__ + "locales/it/Profile.json?hash=a6e0d4a3ca2ab3d0d5393908001ef6ed";